module.exports = __webpack_public_path__ + "img/gq.1ca5663a.png";